import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import React, { type FC, useMemo } from 'react'

type Props = {
  played: number
  duration: number
}

dayjs.extend(duration)

const pad = (str: string | number): string => ('0' + str.toString()).slice(-2)

const formatDuration = (durationInMillisec: number): string => {
  const d = dayjs.duration(durationInMillisec)
  return `${pad(d.minutes())}:${pad(d.seconds())}`
}

export const ControlsDuration: FC<Props> = ({ played, duration }) => {
  const formatedElapsed = useMemo(() => {
    const elapsedDuration = duration * played * 1000
    return formatDuration(elapsedDuration)
  }, [played, duration])

  const formatedDuration = useMemo(
    () => formatDuration(duration * 1000),
    [duration]
  )

  return (
    <div className="absolute bottom-2.5 left-2.5">
      <span className="text-075 font-medium">
        {formatedElapsed}/{formatedDuration}
      </span>
    </div>
  )
}
